module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step0_Titlecard.5bc39f79.jpg";